import { Pipe, PipeTransform } from '@angular/core';

import { staticColumnWidth } from './column-width-utils';
import { SelectOptionMobile } from '@shared/models/catalog.service';
import { CatalogItemValue } from 'app/modules/data/models/catalog';

@Pipe({
  name: 'staticColumnWidth'
})
export class StaticColumnPipe implements PipeTransform {
  public transform(
    column: SelectOptionMobile,
    data: CatalogItemValue[],
    fileColumnNames: string[],
    isGlobalIdColumn: boolean,
    breakPointScreen: number,
    isSortAvailable: boolean,
  ): string {
    const width = staticColumnWidth(data, column, fileColumnNames, isGlobalIdColumn, breakPointScreen, isSortAvailable);
    return `${width}px`;
  }
}
